
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class PsSetItemDtGrid extends Serenity.EntityGrid<PsSetItemDtRow, any> {
        protected getColumnsKey() { return PsSetItemDtColumns.columnsKey; }
        protected getDialogType() { return PsSetItemDtDialog; }
        protected getIdProperty() { return PsSetItemDtRow.idProperty; }
        protected getInsertPermission() { return PsSetItemDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PsSetItemDtRow.localTextPrefix; }
        protected getService() { return PsSetItemDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();


            // var q = Q.parseQueryString();
            // if (q["SysDocNo"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "SysDocNo");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["SysDocNo"];
            //     };
            // }


            return filters;
        }

        
        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected beforeLoadEntity() {
            let self = this;
            

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }
        protected getButtons() {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")


            
            return buttons;
        }
    }
}